import { RiskMatrixDefinition } from 'app/area/case/types-store';
import { RemoteData } from 'app/infrastructure/remote-data/remote-data';
import {
  CaseData, ApiResponse, CasePermissions,
  BowtieSupported, FavouriteDefinition, FavouriteResult, SurveyManagerSupportedData, RiskEvaluationSupported
} from 'app/types-shared';
import { endpoint } from './constants';
import { LayoutType } from 'app/area/reports/containers/chart/types-store';
import { CaseIncludedField } from 'app/area/case-report/case-listing/types';

export const api = {

  casePermissions: async (ids: number[]): Promise<CasePermissions[]> => {

    const response = await new RemoteData(endpoint.casePermissions).resource<ApiResponse<CasePermissions[]>>()
      .filter({ caseId: ids })
      .single();

    return response.data;
  },

  bowtieSupported: async (ids: number[]): Promise<BowtieSupported[]> => {

    const response = await new RemoteData(endpoint.bowtieSupported).resource<ApiResponse<BowtieSupported[]>>()
      .filter({ caseId: ids })
      .single();

    return response.data;
  },

  riskMatrixDefinition: async (caseTypeId: number): Promise<{ caseTypeId: number; definition: RiskMatrixDefinition }> => {

    const response = await new RemoteData(endpoint.riskMatrix).resource<ApiResponse<RiskMatrixDefinition>>()
      .withId(caseTypeId)
      .single();

    return { caseTypeId, definition: response.data };
  },
  
  executeReport: async (definition: FavouriteDefinition, startIndex: number, maxResults: number): Promise<FavouriteResult> => {
    
    const response = await new RemoteData(endpoint.favouriteReport).resource<any>()
      .filter({
        startIndex: startIndex,
        maxResults: maxResults
      })
      .create(definition, false);

    const json = await response.json();

    return json.data;
  },

  deleteCase: async (caseId: number) => {
    return new RemoteData(endpoint.case)
      .resource<ApiResponse<CaseData>>()
      .withId(caseId)
      .httpDelete(caseId);
  },

  surveyManagerSupported: async (id: number[]): Promise<SurveyManagerSupportedData[]> => {

    const response = await new RemoteData(endpoint.surveyManagerSupported).resource<ApiResponse<SurveyManagerSupportedData[]>>()
      .filter({ caseId: id })
      .single();

    return await response.data;
  },

  riskEvaluationSupported: async (id: number[]): Promise<RiskEvaluationSupported[]> => {

    const response = await new RemoteData(endpoint.riskEvaluationSupported).resource<ApiResponse<RiskEvaluationSupported[]>>()
      .filter({ caseId: id })
      .single();

    return response.data;
  },

  loadLayoutTypes: async (reportId: number): Promise<ApiResponse<LayoutType[]>> => {
    return await new RemoteData(endpoint.loadLayoutTypes(reportId))
      .resource<ApiResponse<LayoutType[]>>()
      .all();
  },

  loadDefaultIncludedFields: async (reportId: number): Promise<ApiResponse<{ includedFields: CaseIncludedField[] }>> => {
    return await new RemoteData(endpoint.defaultIncludedFields(reportId))
      .resource<ApiResponse<{ includedFields: CaseIncludedField[] }>>()
      .all();
  },

  loadAdditionalIncludedFields: async ({ caseTypeIds, applicationExcluded, query, reportId }:
    { caseTypeIds: number[]; query?: string; applicationExcluded?: boolean; reportId: number }):
    Promise<ApiResponse<CaseIncludedField[]>> => {
    return await new RemoteData(`${endpoint.additionalIncludedFields}${!!query ? '/search' : ''}`)
      .resource<ApiResponse<CaseIncludedField[]>>()
      .filter({
        query,
        reportId,
        applicationId: caseTypeIds,
        ...(applicationExcluded && { applicationExcluded })
      })
      .all();
  }
};
